import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import AnnouncementBar from "./AnnouncementBar";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/content-plans", label: "Content Plans" },
  { to: "/free-resources", label: "Free Resources" },
  { to: "/community", label: "Community" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <AnnouncementBar />
      <header className="sticky top-0 z-40 glass">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 flex items-center justify-between h-16 sm:h-20">
          <Logo />
          <nav className="hidden lg:flex items-center gap-7">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `text-sm tracking-wide transition-colors duration-300 hover:text-[#F0D77B] ${isActive ? "text-[#D4AF37]" : "text-white/80"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <button
              data-testid="header-book-btn"
              onClick={() => navigate("/services#consultation")}
              className="hidden sm:inline-flex items-center rounded-full bg-gradient-to-r from-[#D4AF37] to-[#F0D77B] px-5 py-2.5 text-sm font-semibold text-[#0A0A0A] gold-glow-hover"
            >
              Book a Consultation
            </button>
            <button
              className="lg:hidden text-white p-2"
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen((v) => !v)}
              aria-label="Menu"
            >
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
        {open && (
          <div className="lg:hidden border-t border-white/10 bg-[#0A0A0A]/95 backdrop-blur-xl" data-testid="mobile-menu">
            <div className="px-4 py-4 flex flex-col gap-1">
              {NAV.map((n) => (
                <Link
                  key={n.to}
                  to={n.to}
                  onClick={() => setOpen(false)}
                  className="py-3 px-2 text-white/85 hover:text-[#D4AF37] border-b border-white/5"
                >
                  {n.label}
                </Link>
              ))}
              <button
                onClick={() => { setOpen(false); navigate("/services#consultation"); }}
                className="mt-3 rounded-full bg-gradient-to-r from-[#D4AF37] to-[#F0D77B] px-5 py-3 font-semibold text-[#0A0A0A]"
              >
                Book a Consultation
              </button>
            </div>
          </div>
        )}
      </header>
    </>
  );
}
